module.exports = __webpack_public_path__ + "static/media/wallclockDetail.70946aab.svg";